import React, {Fragment} from 'react';
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";

import {createUserAlbum, deleteUserAlbum, fetchUserAlbum, updateUserAlbum} from "../../creators/user.album";
import {fetchUserAlbums} from "../../creators/user.albums";

import Icon from "./Icon";
import Alert from "./Alert";
import {PageLoader} from "./Loader";
import {Button} from "./Button";
import {resetAlbum} from "../../creators/album";
import Modal from "./Modal";
import {CheckboxInputField} from "./FormField";


class AlbumInformations extends React.Component {
    constructor(props) {
        super(props);
        this.initialAlbum = {
            title: '',
            description: '',
            right: "guest",
            order : "-createdAt",
            error: false,
            comment: {
                allowed: true,
                toValidate: false
            }
        };
        this.state = {
            currentAlbum: this.initialAlbum,
            createAlbum: false,
            currentAlbumId: 0,
            currentAlbumIdInitial: 0,
            toggleAlert: false,
        };
        this.handleAlbumField = this.handleAlbumField.bind(this);
        this.handleAlbumRight = this.handleAlbumRight.bind(this);
        this.handleSubmitAlbum = this.handleSubmitAlbum.bind(this);
        this.handleDeleteAlbum = this.handleDeleteAlbum.bind(this);
        this.handleComment = this.handleComment.bind(this);

        if (this.props.editAlbum) {
            this.props.fetchUserAlbum(this.props.userId, this.props.currentAlbumId, {nocache : true});
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.currentAlbumId !== this.props.currentAlbumId) {
            this.props.resetAlbum();
            this.props.fetchUserAlbum(this.props.userId, this.props.currentAlbumId);
            this.setState({currentAlbumId: this.props.currentAlbumId || this.props.album._id})
        }
        if (prevProps.album !== this.props.album) {
            this.setState({
                currentAlbum: this.props.album,
            })
        }
    }

    handleComment(key, value = false) {
        this.setState({currentAlbum: {...this.state.currentAlbum, comment: {...this.state.currentAlbum.comment, [key]: value}}})
    }

    handleAlbumField(event) {
        let error = true;
        if(this.state.currentAlbum.title.length >= 3){
            error = false;
        }
        this.setState({currentAlbum: {...this.state.currentAlbum, error, [event.target.name]: event.target.value}});
    }

    handleAlbumRight(value) {
        this.setState({currentAlbum: {...this.state.currentAlbum, right: value}});
    }

    handleAlbumOrder(value) {
        this.setState({currentAlbum: {...this.state.currentAlbum, order: value}});
    }

    handleDeleteAlbum() {
        this.props.deleteUserAlbum(this.props.userId, this.props.currentAlbumId);
        this.props.handleClose();
        // this.props.handleRender();
    }

    handleSubmitAlbum() {
        if (this.state.currentAlbum.title.length >= 3) {
            if (this.props.createAlbum) {
                let currentAlbum = this.state.currentAlbum;
                this.props.createUserAlbum(this.props.userId, currentAlbum);
            } else {
                this.props.updateUserAlbum(this.props.userId, this.props.currentAlbumId, this.state.currentAlbum);
            }
            this.props.handleClose();
            // this.props.handleRender();
            this.setState({currentAlbum: {...this.state.currentAlbum, error: false}});
        } else {
            this.setState({currentAlbum: {...this.state.currentAlbum, error: true}});
        }
    }

    render() {
        return (this.props.createAlbum ? false : !this.props.albumInitialized) ? (
            <div id={"albumInformations"} className={"modal-container"}>
                <PageLoader/>
            </div>
        ) : (
            <div id={"albumInformations"} className={"modal-container"}>
                <div className={"modal-topline"}>
                    {this.props.createAlbum ? (
                        <div className={"album-name"}>
                            Créer un album
                        </div>
                    ) : (
                        <div className={"album-name"}>
                            Editer l'album : <b>{this.state.currentAlbum.title}</b>
                        </div>
                    )}

                    <span onClick={() => this.props.handleClose()}><Icon type={"close"}/></span>
                </div>
                <div className={`album-datas-wrapper modal-body`}>
                    <div className={"informations"}>
                        <div className={"category-title"}><Icon type={"pencil"}/> Informations</div>
                        <input type={"text"}
                               className={`${this.state.currentAlbum.error ? 'error' : ''}`}
                               placeholder={"Titre"} name={"title"}
                               onChange={(event) => this.handleAlbumField(event)}
                               value={this.state.currentAlbum.title || ""}/>
                        {this.state.currentAlbum.error &&
                        <div className={"error-text"}>Vous devez remplir un titre pour votre album.</div>}
                        <textarea placeholder={"Description"} name={"description"}
                                  onChange={(event) => this.handleAlbumField(event)}
                                  value={this.state.currentAlbum.description || ""}/>
                    </div>
                    <div className={"tag-wrapper"}>
                        <div className={"category-title"}><Icon type={"cog"}/> Options</div>
                        <ul className={`filter ${this.state.currentAlbum.right.length === 0 ? 'error' : ''}`}>
                            <li onClick={() => this.handleAlbumRight('guest')}
                                className={this.state.currentAlbum.right === "guest" ? "active" : ""}>Public
                            </li>
                            <li onClick={() => this.handleAlbumRight('public')}
                                className={this.state.currentAlbum.right === "public" ? "active" : ""}>Membres
                            </li>
                            <li onClick={() => this.handleAlbumRight('friends')}
                                className={this.state.currentAlbum.right === "friends" ? "active" : ""}>Amis
                            </li>
                            <li onClick={() => this.handleAlbumRight('private')}
                                className={this.state.currentAlbum.right === "private" ? "active" : ""}>Privé
                            </li>
                        </ul>
                        <div className={"temperature-information"}>
                            {this.state.currentAlbum.right === "guest" && (
                                "Public: L’album n’a pas de restriction, tout le monde peut le voir."
                            )}
                            {this.state.currentAlbum.right === "public" && (
                                "Membres: L’album n’est visible que pour les membres inscrits sur Voissa."
                            )}
                            {this.state.currentAlbum.right === "friends" && (
                                "Amis: Seuls mes amis pourront voir le contenu de l'album"
                            )}
                            {this.state.currentAlbum.right === "private" && (
                                "Privé: Masquera votre album aux autres Voissanautes à l'exception des modérateurs et administrateurs."
                            )}
                        </div>
                        <div className={"category-title mt-8"}>Trier vos medias par</div>
                        <ul className={`filter`}>
                            <li onClick={() => this.handleAlbumOrder('createdAt')}
                                className={this.state.currentAlbum.order === "createdAt" ? "active" : ""}>Date croissante
                            </li>
                            <li onClick={() => this.handleAlbumOrder('-createdAt')}
                                className={this.state.currentAlbum.order === "-createdAt" ? "active" : ""}>Date décroissante
                            </li>
                            <li onClick={() => this.handleAlbumOrder('title')}
                                className={this.state.currentAlbum.order === "title" ? "active" : ""}>Titre
                            </li>

                        </ul>
                        <div className={"album-options-checkbox"}>
                            <CheckboxInputField id="allowed"
                                                htmlFor="allowed"
                                                label={"Permettre aux membres de laisser des commentaires"}
                                                onChange={() => this.handleComment('allowed', !this.state.currentAlbum.comment.allowed)}
                                                checked={this.state.currentAlbum && this.state.currentAlbum.comment && this.state.currentAlbum.comment.allowed}/>

                            <CheckboxInputField id="toValidate"
                                                htmlFor="toValidate"
                                                label={"Me permet d'approuver les commentaires avant qu'ils soient affichés"}
                                                onChange={() => this.handleComment('toValidate', !this.state.currentAlbum.comment.toValidate)}
                                                checked={this.state.currentAlbum && this.state.currentAlbum.comment && this.state.currentAlbum.comment.toValidate}/>
                        </div>
                    </div>
                </div>
                <div className={"modal-baseline"}>
                    <Button btnStyle={"grey"}
                            size={"small"}
                            onClick={() => this.props.handleClose()}
                            content={"Annuler"}/>
                    {this.state.currentAlbum.type === "cover" ? '' : (
                        <Fragment>
                            {this.state.currentAlbumId !== "0" && !this.props.createAlbum ? (
                                <Fragment>
                                    <Button btnStyle={"cancel-reverse"}
                                            size={"small"}
                                            onClick={() => this.setState({toggleAlert: true})}
                                            content={"Supprimer l'album"}/>
                                    <Modal toggle={this.state.toggleAlert}
                                           handleClose={() => this.setState({toggleAlert: false})}>
                                        <Alert handleClose={() => this.setState({toggleAlert: false})}
                                               handleDelete={() => this.handleDeleteAlbum()}
                                               text="Voulez-vous vraiment supprimer cet album et tout son contenu ?"/>
                                    </Modal>
                                </Fragment>
                            ) : ''}
                        </Fragment>
                    )}
                    <Button onClick={() => this.handleSubmitAlbum()}
                            btnStyle={"primary-reverse"}
                            size={"small"}
                            content={this.props.createAlbum ? 'Créer' : 'Modifier'}/>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        album: state.userAlbum.data,
        albumLoading: state.userAlbum.loading,
        albumInitialized: state.userAlbum.initialized,

        albums: state.userAlbums.data
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUserAlbums,

    fetchUserAlbum,
    createUserAlbum,
    updateUserAlbum,
    deleteUserAlbum,
    resetAlbum
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AlbumInformations);